<template>
  <div id="home">
    <welcomeScreenSwitch />
  </div>
</template>

<script setup>
  import { onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'

  import welcomeScreenSwitch from '@/components/homepage/welcomeScreenSwitch.vue'
  
  const route = ref(useRoute())
  /* onMounted(() => {}) */
</script>

<style>
.navbar.zero-bg {
    background-color: #ffffff00;
}
</style>